import { render, staticRenderFns } from "./ArticleTagHeader.vue?vue&type=template&id=b6af5aa4&"
import script from "./ArticleTagHeader.vue?vue&type=script&lang=js&"
export * from "./ArticleTagHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports